import { isValidPhoneNumber } from 'libphonenumber-js/max';
import { ValueObject } from './value-object';
import { normalizePhoneNumber } from '../../core/utils/normalize-phone-number';

export class PhoneNumber extends ValueObject<string | number> {
  constructor(phoneNumber: string | number) {
    const isValid = PhoneNumber.validate(phoneNumber);
    if (!isValid) throw new Error('Not a valid phone number');

    const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber);
    super(normalizedPhoneNumber);
  }

  static validate(input: string | number): boolean {
    const phoneNumberAsString = input.toString();

    const isValidBrazilianNumber = isValidPhoneNumber(phoneNumberAsString, 'BR');
    if (isValidBrazilianNumber) return true;
    const numberWithPlus = phoneNumberAsString.startsWith('+') ? phoneNumberAsString : `+${phoneNumberAsString}`;
    const isValidInternationalNumber = isValidPhoneNumber(numberWithPlus);
    return isValidInternationalNumber;
  }
}
